import { render, staticRenderFns } from "./CalcFormItemWind.vue?vue&type=template&id=3d40a8fc&"
import script from "./CalcFormItemWind.vue?vue&type=script&lang=js&"
export * from "./CalcFormItemWind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports